<template>
  <router-view/>
</template>

<style lang="scss">
html {
  scroll-behavior: smooth;
}

body {
  margin: 0;
  padding: 0;
  background-color: #dfdfdf;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  font-family: monospace;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  overflow: hidden;
}

h1,
h2,
p {
  margin: 0;
}

h1,
h2 {
  letter-spacing: 1px;
}

h2 {
  font-size: 24px;
  margin-bottom: 16px;
}

img {
  width: 100%;
}

@media screen and (min-width: 768px) {
  h2 {
    font-size: 48px;
    margin-bottom: 40px;
  }
}

</style>
